/*
 * Copyright (c) Logan Group Services - Gaston Longhitano <gaston.longhitano@logangroupservices.com>
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, {useEffect} from 'react';
import './reset2.css'
import './App.scss'
import {RecoilRoot} from 'recoil';
//import ErrorBoundary from './ErrorBoundary';
import ErrorScreen from './components/ErrorScreen';
import Game from './components/Game'
import Loader from './elements/Loader/Loader';

import * as Sentry from '@sentry/react';

function GamePlayer() {
  return (
      <div className="App">
        <RecoilRoot>
          <Sentry.ErrorBoundary fallback={ErrorScreen}>
            <React.Suspense fallback={<Loader />}>
              <Game />
            </React.Suspense>
          </Sentry.ErrorBoundary>
        </RecoilRoot>
      </div>
  );
}

export default GamePlayer;
